import logo from './../logo.svg';
import './../styles/Home.css';

function Home() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
        <a href='https://www.google.co.uk/' target='_blank' rel="noopener noreferrer">
          Home
        </a>
      </header>
    </div>
  );
}

export default Home;